<template>
  <div>
    <div class="events-list-wrap roster-list-wrap" v-if="!club.coachDowngraded">
      <div class="top-head">
        <div class="container">
          <div class="list-wrap">
            <div class="back">
              <router-link v-if="!hideButton" :to="backToProfileLink">
                <a-icon type="arrow-left" />Back to profile
              </router-link>
            </div>
            <div class="event-types" v-if="!$route.params.id">
              <div
                class="type"
                :class="{ active: showActive }"
                @click="setActive(true)"
              >
                New Roster
              </div>
              <div
                class="type"
                :class="{ active: !showActive }"
                @click="setActive(false)"
              >
                Deactivated Players
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="roster-content-wrap events-content-wrap">
          <div class="head">
            <div class="head-title">
              <div class="name">{{ club.clubName }}</div>
              <h2 class="form-title">Roster</h2>
            </div>

            <div class="add-event" v-if="!$route.params.id">
              <a-button
                type="primary"
                class="add-event-btn"
                icon="plus"
                @click="handleNewRoster"
                v-if="!club.coachDowngraded"
                >Add New Player</a-button
              >
            </div>
          </div>
          <div class="roster-wrap">
            <a-row :gutter="[24, 32]">
              <a-col
                :xs="24"
                :sm="12"
                :md="8"
                :lg="6"
                v-for="(roster, index) in rosterList"
                :key="index"
              >
                <RosterCard
                  :active="showActive"
                  :key="index"
                  :roster="roster"
                />
              </a-col>
            </a-row>
          </div>
        </div>
      </div>
    </div>
    <div class="no-access-msg-container" v-else>
      <p class="no-access-msg">
        Please upgrade your profile to create/view rosters. Upgrade options are
        located in "My Account" section below your profile icon.
      </p>
    </div>
  </div>
</template>

<script>
import RosterCard from "./card";
import { mapGetters } from "vuex";
import { Base } from "@/models";

const STORE_KEY = "rosterStore";
const CLUB_STORE_KEY = "clubStore";

export default {
  name: "RosterList",
  components: {
    RosterCard,
  },
  data() {
    return {
      showActive: true,
    };
  },
  computed: {
    ...mapGetters({
      rosterList: `${STORE_KEY}/rosterList`,
      rosterListLoading: `${STORE_KEY}/rosterListLoading`,
      club: `${CLUB_STORE_KEY}/club`,
    }),
    clubId() {
      return this.$route.params.id || localStorage["club-id"];
    },
    hideButton() {
      return localStorage["club-id"] === this.club.id;
    },
    profileId() {
      return Base.profileId();
    },
    backToProfileLink() {
      if (this.$route.params.id)
        return `/${this.$route.params.profileId}/club_profile/${this.$route.params.id}/summary`;
      return `/${this.$route.params.profileId}/club_profile/summary`;
    },
  },
  mounted() {
    this.$store.dispatch(`${CLUB_STORE_KEY}/getClub`, {
      id: this.clubId,
    });
    this.getRoster();
    console.log(this.rosterList);
  },
  methods: {
    setActive(val) {
      this.showActive = val;
      this.getRoster();
    },
    getRoster() {
      this.$store.dispatch(`${STORE_KEY}/getRosterList`, {
        isActive: this.showActive,
        clubId: this.clubId,
      });
    },
    handleNewRoster() {
      this.$router.push(`/${this.profileId}/roster/new`);
    },
  },
};
</script>

<style lang="scss">
.no-access-msg-container {
  padding: 70px 0 70px 0;
  .no-access-msg {
    color: #000;
    font-weight: bolder;
    font-size: 1.3em;
    text-align: center;
  }
}
.roster-list-wrap {
  .roster-content-wrap {
    padding-top: 60px;
    .head {
      margin-bottom: 40px;
      .form-title {
        font-size: 24px;
      }
    }
    .roster-wrap {
      .ant-row {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
      }
    }
  }
}
.active {
  color: #d73228 !important;
}
</style>
